import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortals = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M10 17.5h5a2.5 2.5 0 0 0 2.5-2.5V5A2.5 2.5 0 0 0 15 2.5H5A2.5 2.5 0 0 0 2.5 5v5M2.5 7.5h15"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M9.167 4.996 9.162 5l.005.004L9.17 5zM7.083 4.996 7.08 5l.004.004L7.088 5zM5 4.996 4.996 5 5 5.004 5.004 5zM2.5 13.333A4.167 4.167 0 0 1 6.667 17.5M2.5 15.833c.92 0 1.667.746 1.667 1.667"
	})]
});
export default SvgPortals;
